import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../../components/ui/dialog";
import { useI18n } from "../../../i18n";
import { api } from "../../../lib/api";
import { fmtMoney } from "../../../lib/format";
import { payErr } from "../../../lib/payments";
import { Field, btnPrimary, chip, input } from "../../../components/common/Page";

// Collections: send the customer a link for the overdue amount, the whole balance or a chosen amount.
export const PayLinkDialog = ({ row, onClose, onSent }) => {
  const { t } = useI18n();
  const [f, setF] = useState({ scope: "overdue", amount: "", channel: "email" });
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const send = async () => {
    const win = f.channel === "whatsapp" ? window.open("", "_blank") : null;
    setBusy(true);
    try {
      const { data } = await api.post("/staff/payments/links", { customer_code: row.code, scope: f.scope, channel: f.channel,
        amount: f.scope === "custom" ? Number(String(f.amount).replace(",", ".")) : null });
      if (win && data.whatsapp_url) win.location.href = data.whatsapp_url;
      setRes(data); toast.success(t("x.pay.linkSent")); onSent();
    } catch (e) { if (win) win.close(); toast.error(payErr(t, e)); } finally { setBusy(false); }
  };
  const copy = () => navigator.clipboard?.writeText(res.url).then(() => toast.success(t("x.pay.linkCopied")));
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-[calc(100vw-2rem)] sm:max-w-lg" data-testid="pay-link-dialog">
        <DialogHeader><DialogTitle>{t("x.pay.linkTitle")} · {row.name}</DialogTitle></DialogHeader>
        <div className="min-w-0 space-y-3">
          <Field label={t("x.pay.what")}>
            <div className="flex flex-wrap gap-2">{["overdue", "balance", "custom"].map((k) => <button key={k} type="button" className={chip(f.scope === k)} onClick={() => setF((s) => ({ ...s, scope: k }))} data-testid={`pay-link-scope-${k}`}>{t(`x.pay.${k}`)}{k === "overdue" ? ` · ${fmtMoney(row.overdue)}` : k === "balance" ? ` · ${fmtMoney(row.balance)}` : ""}</button>)}</div>
          </Field>
          {f.scope === "custom" && <Field label={t("x.pay.amount")}><input inputMode="decimal" value={f.amount} onChange={(e) => setF((s) => ({ ...s, amount: e.target.value }))} className={input} data-testid="pay-link-amount" /></Field>}
          <Field label={t("x.pay.channel")}>
            <div className="flex flex-wrap gap-2">{["email", "push", "whatsapp"].map((k) => <button key={k} type="button" className={chip(f.channel === k)} onClick={() => setF((s) => ({ ...s, channel: k }))} data-testid={`pay-link-channel-${k}`}>{t(`x.pay.${k}`)}</button>)}</div>
          </Field>
          <button type="button" disabled={busy} onClick={send} className={`${btnPrimary} w-full`} data-testid="pay-link-send">{t("x.pay.send")}</button>
          {res && <button type="button" onClick={copy} className="block w-full truncate rounded-xl bg-slate-50 px-3 py-2 text-left text-xs text-navy" data-testid="pay-link-url">{res.url}</button>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
